module.exports = __webpack_public_path__ + "img/Sepah.3146a3cd.svg";